import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Plus, Trash2, ImageIcon, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { API } from "../lib/api";

export default function PartnersPanel() {
  const [partners, setPartners] = useState([]);
  const [name, setName] = useState("");
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const reload = () => {
    api
      .get("/partners")
      .then((r) => setPartners(r.data))
      .catch(() => toast.error("Errore caricamento"));
  };
  useEffect(() => {
    reload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const upload = async (e) => {
    e.preventDefault();
    if (!name || !file) {
      toast.error("Inserisci nome e seleziona un'immagine");
      return;
    }
    const data = new FormData();
    data.append("name", name);
    data.append("file", file);
    setUploading(true);
    try {
      await api.post("/partners", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("Partner aggiunto");
      setName("");
      setFile(null);
      document.getElementById("partner-file-input").value = "";
      reload();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore upload");
    } finally {
      setUploading(false);
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Eliminare questo partner?")) return;
    await api.delete(`/partners/${id}`);
    toast.success("Eliminato");
    reload();
  };

  return (
    <div className="space-y-6">
      <form
        onSubmit={upload}
        className="bg-[#0E0E11] border border-white/10 rounded-2xl p-6"
        style={{ borderTop: "4px solid #FF5722" }}
      >
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-orange-500/10 border border-orange-500/30 text-orange-300">
            <ImageIcon className="w-5 h-5" />
          </div>
          <div>
            <h3 className="font-bold">Aggiungi Partner Ufficiale</h3>
            <p className="text-xs text-white/50">
              Logo visibile nel carosello in fondo alla home (mostrato 150×150 max)
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-4 items-end">
          <div className="md:col-span-1">
            <Label className="text-xs uppercase tracking-wider text-white/60">Nome partner</Label>
            <Input
              data-testid="partner-name-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="es. ASD Danza Italia"
              className="mt-1 bg-black/60 border-white/10 text-white"
            />
          </div>
          <div className="md:col-span-1">
            <Label className="text-xs uppercase tracking-wider text-white/60">Logo (PNG/JPG/WEBP/SVG)</Label>
            <Input
              id="partner-file-input"
              data-testid="partner-file-input"
              type="file"
              accept="image/*"
              onChange={(e) => setFile(e.target.files?.[0] || null)}
              className="mt-1 bg-black/60 border-white/10 text-white file:text-white"
            />
          </div>
          <Button
            type="submit"
            disabled={uploading}
            data-testid="partner-upload-btn"
            className="rounded-full bg-gradient-to-r from-[#FF5722] to-[#00E5FF] border-0"
          >
            {uploading ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <>
                <Plus className="w-4 h-4 mr-1" /> Carica
              </>
            )}
          </Button>
        </div>
      </form>

      <div className="bg-[#0E0E11] border border-white/10 rounded-2xl p-5">
        <div className="text-sm text-white/60 mb-4">{partners.length} partner caricati</div>
        {partners.length === 0 ? (
          <div className="text-center text-white/50 py-10">Nessun partner caricato</div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {partners.map((p) => (
              <div
                key={p.id}
                data-testid={`partner-tile-${p.id}`}
                className="group bg-white/5 border border-white/10 rounded-xl p-3 flex flex-col items-center"
              >
                <div className="w-full h-32 flex items-center justify-center bg-black/40 rounded-lg overflow-hidden">
                  <img
                    src={`${API}/partners/${p.id}/image`}
                    alt={p.name}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
                <div className="mt-2 text-xs font-medium text-white/80 text-center break-all line-clamp-1">
                  {p.name}
                </div>
                <Button
                  size="sm"
                  variant="ghost"
                  onClick={() => remove(p.id)}
                  data-testid={`partner-delete-${p.id}`}
                  className="mt-1 text-red-300 hover:bg-red-500/20 h-7 px-2"
                >
                  <Trash2 className="w-3.5 h-3.5" />
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
